




































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import MainHeader from '@/components/MainHeader'
import TableComponent from '@/components/TableComponent'
import DocumentModal from '../DocumentModal'
//   import { FicationAdd, FicationEdit } from '@/api/advicenote'
import { FileTypeList, getByCusr, getselectAllVlaue } from '@/api/utils'
import { doAddSuperivision,getWritenSuperivisionInfo,updateSuperivision } from '@/api/supervision'
import { getLocalItem } from '@/utils'
//   import {getLocalItem} from '@/utils'
//   import Upload from '@/components/Uploader/index'
import store from '@/store'
import moment from 'moment'
@Component({
  name: 'Examine',
  components: { MainHeader, TableComponent, DocumentModal },
})
export default class Examine extends Vue {
  $refs!: { table: HTMLFormElement; ruleForm: HTMLFormElement };
  // $refs!: { ruleForm: HTMLFormElement  }
  private form: any = '';
  private action: string = 'add';
  private showRtn: boolean = true;
  private showAddDoc: boolean = false;
  private showDCM: boolean = false;
  private person: any = [];
  private searchParams: any = {
    enterprise: undefined,
    EntErpriSe: undefined,
  };
  private docData: any = null;
  private headerArr = ['书面监察', '书面监察新增'];
  //   private somell:string = '菏泽玉皇化工'
  private actioning: string =
    process.env.VUE_APP_API_BASE_URL +
    '/front/supervision/v1/supervisionUploadFile/commonUpload';
  private loading: boolean = false;
  private visible: boolean = false;
  private recordId: string = '';
  private promas: any = {};
  private user: any = '';
  private regionList: any = [];
  private hint: boolean = false;
  private filelistType: any = '';
  //   private formData: any = {
  //     enterpriseCode: '',
  //     fileTypeList: [],
  //     lawEnforcer: [],
  //     status: 0,
  //   };
  private dataSource: any = [];
  private fileTypeId: any = '';
  private datalevel: any = [];
  private idauthentication: string = '';
  private uploadata: any = {};
  private fileList: any = []; //编辑的时候改变它
  private headers: any = {
    Authorization: Vue.ls.get('ACCESS_TOKEN'),
  };
  private images: any = {};
  private columns: any = [
    {
      title: '文件名称',
      dataIndex: 'documentName',
      key: 'documentName',
      customRender: (text: any, row: any, index: any) => {
        return text ? text : '-'
      },
    },
    {
      title: '下发时间',
      dataIndex: 'documentIssueTime',
      key: 'documentIssueTime',
      // customRender: (text: any, row: any, index: any) => {
      //   return text ? text : '-'
      // },
    },
    {
      title: '下发状态',
      dataIndex: 'documentIssueState',
      key: 'documentIssueState',
      customRender: (text: any, row: any, index: any) => {
        return text===2 ? '已下发' : '未下发'
      },
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ];
  // private data: any = [
  //   {
  //     documentName:'菏泽市节能监察文件',
  //     upLoadUserName:'李强'
  //   }
  // ];
  disabledDate(current: any) {
    return current < moment().subtract(0, 'day') //今天之前的年月日不可选，不包括今天
  }
  /** 下拉绑定 */
  filterOption(input: any, option: any) {
    return (
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    )
  }
  private docID:any = '' // 文书id
  handleEdit(value:any) {
    this.docID= value.id
    this.showDCM = true
    this.showAddDoc = true
  }
  private supervisionPlanTime:any = ''
  onChangeTime(date:any,dateString:any){
    this.supervisionPlanTime = dateString
  }
  addDoc() {
    if (this.tableData.length > 0) {
      this.$message.warning('当前记录只能添加一条文书')
      return
    }
    this.showDCM = true
    this.showAddDoc = true
  }
  docCallBack(data: any) {
    this.docData = data
    if (this.tableData.length > 0) {
      this.tableData = []
    }
    this.tableData.push(data)
this.$refs.table.refresh(true)
  }
  private reset:any =false
  handDeletDoc() {
    this.tableData = []
    this.docData ={}
    this.reset = true
    // this.docData.isNews = 'isnew'
    this.$refs.table.refresh(true)
  }
  closeDoc() {
    this.showDCM = false
    this.showAddDoc = false
  }
  // 将已上传的文件id发送后端绑定
  issueAnotice(val: number) {
    this.form.validateFields((err: any, value: any) => {
      if(!this.docData){
        this.$message.warning('请添加一个文书')
        return false
      }
      if (!this.docData.documentName) {
        this.$message.warning('请添加一个文书')
        return false
      }
      
      if (!err) {
        const postData: any = {}
        postData.enterpriseCustId = value.enterpriseCustId.key
        postData.status = val
        postData.lawEnforcerUserList =value.lawEnforcerUserList&&value.lawEnforcerUserList.map(
          (item: any) => {
            return {lawEnforcerUserId:item.key} 
          }
        )
        postData.documentInfo = this.docData
        
        
        postData.supervisionPlanTime = this.supervisionPlanTime
        if(this.action!=='update'){
            delete postData.documentInfo.id
     
        doAddSuperivision(postData).then((res: any) => {
          if (res && res.status=== 0) {
            if (val === 1) {
              this.$message.success('保存成功')
            } else {
              this.$message.success('保存并下发成功')
            }
            this.handleReturn()
          } else {
            this.$message.error(res.message)
          }
        })} else {
          postData.documentInfo ={}
          postData.documentInfo.id =  this.currDocID
          postData.id = this.$route.query.id
          postData.documentInfo.documentContent = this.docData.documentContent
          postData.documentInfo.documentName   = this.docData.documentName
          // postData.documentInfo.id = this.docData.documentid
          updateSuperivision(postData).then((res:any)=>{
             if (res && res.status=== 0) {
            if (val === 1) {
              this.$message.success('保存成功')
            } else {
              this.$message.success('保存并下发成功')
            }
            this.handleReturn()
          } else {
            this.$message.error(res.message)
          }
          })
        }
      }
    })
    //   this.formData.status = val
    //   if (!this.searchParams.enterprise) {
    //   this.$message.warning('请选择企业')
    //   return
    //   }
    //   this.formData.enterpriseCode = this.searchParams.enterprise
    //   var _this = this
    //   _this.formData.recordId = _this.$route.query.recordId
    //   if (val === 1) {
    //   this.$confirm({
    //   title: '下发确认',
    //   content: '是否要下发?',
    //   cancelText: '取消',
    //   okText: '确认',
    //   onOk: function () {
    //   if (_this.action === 'add') {
    //   FicationAdd(_this.formData).then(res => {
    //   _this.$message.success('添加成功')
    //   _this.handleReturn()
    //   }).catch(err => {
    //   _this.$message.error(err.message)
    //   })
    //   } else {
    //   FicationEdit(_this.formData).then(res => {
    //   _this.$message.success('修改成功')
    //   _this.handleReturn()
    //   }).catch(err => {
    //   _this.$message.error(err.message)
    //   })
    //   }
    //   }
    //   })
    //   } else {
    //   if (this.action === 'add') {
    //   FicationAdd(this.formData).then(res => {
    //   _this.$message.success('添加成功')
    //   _this.handleReturn()
    //   }).catch(err => {
    //   _this.$message.error(err.message)
    //   })
    //   } else {
    //   FicationEdit(this.formData).then(res => {
    //   _this.$message.success('修改成功')
    //   _this.handleReturn()
    //   }).catch(err => {
    //   _this.$message.error(err.message)
    //   })
    //   }
    //   }
  }
  handleChange(emint: any) {
    this.searchParams.enterprise = emint.key
    this.searchParams.EntErpriSe = emint
  }
  upLoding(data: any) {
    var _this = this
    const timeage = moment(new Date()).format('YYYY-MM-DD')
    // _this.formData.fileTypeList.forEach((element: any, index: number) => {
    //   if (element.fileTypeId == data.fileTypeId) {
    //     if (data.fileList.length > 0) {
    //       element.files = data.fileList
    //       _this.data[index].createTime = timeage
    //       _this.data[index].upLoadUserName = _this.user.realName
    //     } else {
    //       element.files = data.fileList
    //       _this.data[index].createTime = ''
    //       _this.data[index].upLoadUserName = ''
    //     }
    //   }
    // })
  }
  // 选择公司名称的改变事件
  handlecaleChange(value: any) {
    this.searchParams.enterprise = value
  }
  // cancel 取消
  handlecancel() {
    this.visible = false
    this.fileList = []
    this.datalevel = []
  }
  // OK确认
  handleOk() {
    this.fileList = []
    this.visible = false
  }
  // 返回按钮
  handleReturn() {
    this.$router.replace({ name: 'WrittenSupervision' })
  }
  private tableData: any = [];
  private getList() {
    const that = this
    return new Promise(function (resolve: any, reject: any) {
      const data = {
        status: 0,
        data: that.tableData,
      }
      return resolve(data)
    })
  }

  // 获取列表或者获取列表和列表下的文件
  //   getList() {
  //   const data = {
  //   functionType:1,
  //   recordId:this.action!='add'?this.recordId: ''
  //   }
  //   FileTypeList(data).then(res => {
  //   this.data = res.data
  //   if (this.action != 'add') {
  //   this.data.forEach((element:any,indexe:number) => {
  //   this.formData.fileTypeList.push({
  //   fileTypeId:element.fileTypeId,
  //   files:element.files
  //   })
  //   })
  //   } else {
  //   this.data.forEach((element:any,indexe:number) => {
  //   this.formData.fileTypeList.push({
  //   fileTypeId:element.fileTypeId,
  //   files:element.files
  //   })
  //   })
  //   this.fileList = []
  //   }
  //   })
  //   }
  // 点击上传或者查看
  derlogin(row: any) {
    //   store.state.commonStore.fileTypeId = row.fileTypeId
    this.filelistType = row.fileType * 1
    // for (var item of this.formData.fileTypeList) {
    //   if (item.fileTypeId === row.fileTypeId) {
    //     item.files.forEach((element: any, index: number) => {
    //       element.type = element.fileName
    //         .substring(element.fileName.lastIndexOf('.'))
    //         .toLowerCase()
    //       element.uid = element.id
    //       element.name = element.fileName
    //       element.url = element.filePath
    //     })
    //     this.fileList = item.files
    //     this.images = item.files
    //     this.visible = true
    //     return
    //   }
    // }
  }
  mounted() {
    if(this.action === 'update'){
       this.headerArr = ['书面监察', '书面监察编辑']
      }
    getselectAllVlaue().then((res) => {
      this.person = res.data
      
      // if (this.status !='0') {
      //   var value:any
      //   value = this.$route.query.lawEnforcer
      //   for(var item of value) {
      //     this.person.forEach((element:any,index:number) => {
      //       if(item == element.userId) {
      //         this.formData.Ynforcer.push({
      //           key:item,
      //           label:element.realName
      //         })
      //       }
      //     })
      //   }
      // }
    })
    // if (this.action !== 'update') {
    //     this.form.setFieldsValue({
    //       'lawEnforcerUserList': [
    //         {
    //           key: this.client.id,
    //           label: this.client.realName,
    //         },
    //       ],
    //     })
    //   }
  }
  private infoid:any = ''
  private infoData:any = null
   private client:any =getLocalItem('client')
   private currDocID:String = ''
  created() {
    this.form = this.$form.createForm(this)
    if(this.$route.query.id){
      this.action = 'update'
      this.infoid = this.$route.query.id

    getWritenSuperivisionInfo(this.infoid).then((res: any) => {
      if (res && res.status === 0) {
        this.infoData = res.data
        this.currDocID = this.infoData.documentInfo.id
        this.$nextTick(() => {
          this.form.setFieldsValue({
            enterpriseCustId: {
              key: res.data.enterpriseCustId,
              label: res.data.enterpriseCustName,
            },
            lawEnforcerUserList: res.data.lawEnforcerUserList.map(
              (item: any) => {
                return {
                  key: item.lawEnforcerUserId,
                  label: item.lawEnforcerUserName,
                }
              }
            ),
         supervisionPlanTime:moment(res.data.supervisionPlanTime).format('YYYY-MM-DD HH:mm:ss') ,
          })
        })
        this.supervisionPlanTime = moment(res.data.supervisionPlanTime).format('YYYY-MM-DD HH:mm:ss')
        this.tableData.push(res.data.documentInfo)
        this.docData = res.data.documentInfo
        // this.fileData = res.data.enterpriseFileInfoList
        // this.$refs.filetable.refresh(true)
        // this.fileData.push(res.data.)
        // this.getfileList()
      }
    })
    }
    
    // this.action = this.$route.query.type.toString()
    // if (this.action == 'add') {
    //   this.somell = ''
    // } else {
    //   this.recordId = this.$route.query.recordId.toString()
    //   this.somell = this.$route.query.somell.toString()
    //   let text = ''
    //   this.regionList.forEach((element: any, index: number) => {
    //     if (element.enterpriseCode == this.$route.query.enterpriseCode) {
    //       text = element.enterpriseName
    //     }
    //   })
    //   this.searchParams.enterprise =
    //     this.$route.query.enterpriseCode.toString()
    //   this.searchParams.EntErpriSe = {
    //     key: this.$route.query.enterpriseCode,
    //     label: text,
    //   }
    // }
    //   this.getList()
    // FileTypeList({functionType:1}).then(res => {
    //     this.data = res.data
    // })
    getByCusr().then((res) => {
      this.regionList = res.data
    })
  }
}
